type RoomEvidence={source?:string;area_m2?:number|null;out_of_scope?:boolean;is_void?:boolean};
/** Drawing geometry or customer-entered dimensions are not evidence of an onsite laser measure. */
export function proposalHasVerifiedMeasurements(rooms:readonly RoomEvidence[]=[]):boolean{
 const included=rooms.filter(room=>!room.out_of_scope&&!room.is_void);
 return included.length>0&&included.every(room=>room.source==='onsite_laser'&&typeof room.area_m2==='number'&&Number.isFinite(room.area_m2)&&room.area_m2>0);
}
